import _slicedToArray from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var converter = {
  // convert list of object to an array
  O2A: function O2A(data) {
    var converted = [];
    //LOOPING EACH CHILD AND PUSHING TO ARRAY
    for (var _i = 0, _Object$entries = Object.entries(data.val()); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      value['object_key'] = key;
      converted.push(value);
    }
    return converted;
  },
  // Reverse array supplied
  ReverseO2A: function ReverseO2A(data) {
    return data.reverse();
  },
  // Return the first Item in the array
  FirstO2A: function FirstO2A(data) {
    return data[0];
  },
  // Return the last Item in the array
  LastO2A: function LastO2A(data) {
    return data.slice(-1)[0];
  },
  // Return N number of items in array
  GetNO2A: function GetNO2A(data, number) {
    return data.slice(0, number);
  },
  // get total count of data in array
  CountO2A: function CountO2A(data) {
    return data.length;
  }
};
export default converter;